let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1mlos")).then(() => parcelRequire('jaOZS'));